import type { ReactNode } from 'react'

import { styled } from 'styled-components'

const Banner = styled.div<{ $color: string }>`
  align-items: center;
  background: ${(o) => o.$color};
  color: white;
  display: flex;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 0.5rem;
  letter-spacing: 0.05em;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
`

const Dot = styled.span`
  background: white;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  height: 0.5rem;
  opacity: 0.85;
  width: 0.5rem;
`

export const StatusBanner = ({
  color,
  children,
}: {
  color: string
  children: ReactNode
}) => (
  <Banner $color={color}>
    <Dot />
    {children}
  </Banner>
)
